/** Renders one `<script type="application/ld+json">` block. Google accepts structured data
 * anywhere in the document (head or body); rendering it as a normal element here means it's
 * serialized into the prerendered static HTML the same as any other markup — no `<Head>`
 * indirection needed. */
export function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
